import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import DestinationsSection from './components/DestinationsSection';
import WhyUsSection from './components/WhyUsSection';
import CTABannerSection from './components/CTABannerSection';
import AboutSection from './components/AboutSection';
import LeadershipSection from './components/LeadershipSection';
import ReviewsSection from './components/ReviewsSection';
import BlogSection from './components/BlogSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import PageLoader from '@/components/feature/PageLoader';
import CursorEffect from '@/components/feature/CursorEffect';
import AmbientBackground from '@/components/feature/AmbientBackground';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <a href="#main-content" className="skip-to-content">Skip to content</a>
      <PageLoader />
      <CursorEffect />
      <AmbientBackground />
      <Navbar />
      <main id="main-content" className="relative z-[1]">
        <HeroSection />
        <ServicesSection />
        <DestinationsSection />
        <WhyUsSection />
        <CTABannerSection />
        <AboutSection />
        <LeadershipSection />
        <ReviewsSection />
        <BlogSection />
        <ContactSection />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}